<template>
  <div class="partner-components">
    <div class="container">
      <!--	圆心-->
      <!-- <div class="circle"><span style="line-height: 84px;">圆心</span></div> -->
      <!--	外层-->
      <div class="borther">
        <div id="lopp"></div>
        <div class="ball" @mouseenter="onMouseGo()" @mouseout="onMouseMove()" @click="clickMsg(this)">
          <img :src="list[0]" alt="" srcset="" style="width: 120px">
        </div>
        <div class="ball" @mouseenter="onMouseGo()" @mouseout="onMouseMove()" @click="clickMsg(this)">
          <img :src="list[1]" alt="" srcset="" style="width: 120px"></div>
        <div class="ball" @mouseenter="onMouseGo()" @mouseout="onMouseMove()" @click="clickMsg(this)">
          <img :src="list[2]" alt="" srcset="" style="width: 120px"></div>
        <div class="ball" @mouseenter="onMouseGo()" @mouseout="onMouseMove()" @click="clickMsg(this)">
          <img :src="list[3]" alt="" srcset="" style="width: 120px">
        </div>
        <div class="ball" @mouseenter="onMouseGo()" @mouseout="onMouseMove()" @click="clickMsg(this)">
          <img :src="list[4]" alt="" srcset="" style="width: 120px">
        </div>
      </div>
      <!--	里层-->
      <div class="borther2">
        <div id="lopp2"></div>
        <div class="ball ball2" @mouseenter="onMouseGo()" @mouseout="onMouseMove()" @click="clickMsg(this)">
          <img :src="list[5]" alt="" srcset="" style="width: 200px">
        </div>
        <div class="ball ball2" @mouseenter="onMouseGo()" @mouseout="onMouseMove()" @click="clickMsg(this)">
          <img :src="list[6]" alt="" srcset="" style="width: 200px">
        </div>
        <div class="ball ball2" @mouseenter="onMouseGo()" @mouseout="onMouseMove()" @click="clickMsg(this)">
          <img :src="list[7]" alt="" srcset="" style="width: 200px">
        </div>
        <div class="ball ball2" @mouseenter="onMouseGo()" @mouseout="onMouseMove()" @click="clickMsg(this)">
          <img :src="list[8]" alt="" srcset="" style="width: 200px">
        </div>
        <div class="ball ball2" @mouseenter="onMouseGo()" @mouseout="onMouseMove()" @click="clickMsg(this)">
          <img :src="list[9]" alt="" srcset="" style="width: 200px">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    this.init()
  },
  data() {
    return {
      list: [
        'https://ssv-website.oss-cn-shenzhen.aliyuncs.com/mainland/image/1662431447513290526.png',
        'https://ssv-website.oss-cn-shenzhen.aliyuncs.com/mainland/image/1662431460258204364.png',
        'https://ssv-website.oss-cn-shenzhen.aliyuncs.com/mainland/image/1662431464473945839.png',
        'https://ssv-website.oss-cn-shenzhen.aliyuncs.com/mainland/image/1662431468274332098.png',
        'https://ssv-website.oss-cn-shenzhen.aliyuncs.com/mainland/image/1662431472271585804.png',
        'https://ssv-website.oss-cn-shenzhen.aliyuncs.com/mainland/image/1662431475732365187.png',
        'https://ssv-website.oss-cn-shenzhen.aliyuncs.com/mainland/image/1662431478989756237.png',
        'https://ssv-website.oss-cn-shenzhen.aliyuncs.com/mainland/image/1662431484197725582.png',
        'https://ssv-website.oss-cn-shenzhen.aliyuncs.com/mainland/image/1662431487889110640.png',
        'https://ssv-website.oss-cn-shenzhen.aliyuncs.com/mainland/image/1662431491473534629.png',
      ],
      items: []
    }
  },
  methods: {
    init() {
      const items = document.querySelectorAll('.ball');
      for (let i = 0; i < items.length; i++) {
        (function (i) {
          items[i].style['animation-delay'] = (-5) - 4 * i + 's,' + (-4 * i) + 's,' + (-4 * i) + 's'
        })(i);
      }
      this.items = items
    },
    onMouseGo() {
      // for (let i = 0; i < this.items.length; i++) {
      //   (function (i) {
      //     this.items[i].classList.add('active')
      //   })(i);
      // }
    },
    onMouseMove() {
      // for (let i = 0; i < this.items.length; i++) {
      //   (function (i) {
      //     this.items[i].classList.remove('active')
      //   })(i);
      // }
    },
    clickMsg(e) {
    }
  }
}
</script>

<style>
.partner-components {
  background: url('https://ssv-website.oss-cn-shenzhen.aliyuncs.com/mainland/video/1662654134138480363.gif') no-repeat no-repeat;
  background-size: cover;
  display: flex;
  align-items: center;
  height: 800px;
}

/*第一层*/
@keyframes animX {
  0% {
    left: 0px;
  }
  100% {
    left: 1000px;
  }
}

@keyframes animY {
  0% {
    top: 0px;
  }
  100% {
    top: 600px;
  }
}

@keyframes scale {

  0% {
    transform: scale(0.4);
    z-index: 0
  }
  50% {
    transform: scale(1);
    z-index: 3
  }
  100% {
    transform: scale(0.5);
    z-index: 0
  }
}


.ball {
  width: 105px;
  height: 105px;
  /*background-color: #f66;*/
  border-radius: 50%;
  position: absolute;
  color: #fff;
  font-size: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  /**background: yellow;**/
  background-size: 100% 100%;
  -webkit-background-size: 100% 100%;
  line-height: 120px;
  z-index: 3;
  /*动画执行一次所需时间*/
  animation-duration: 10s, 10s, 20s;
  /*动画以何种运行轨迹完成一个周期*/
  animation-timing-function: cubic-bezier(0.36, 0, 0.64, 1);
  /*动画播放次数,无线循环播放*/
  animation-iteration-count: infinite;
  /*是否轮流反向播放动画 alternate:正向播放*/
  animation-direction: alternate;
  animation-name: animX, animY, scale;
}

#lopp {
  width: 1000px;
  height: 600px;
  border: 2px solid #fff;
  border-radius: 50%;
  position: absolute;
  left: 50px;
  top: 50px;
  /*transform: translate(-50%, -50%)*/
}

/*鼠标进入停止*/
.active {
  animation-play-state: paused;
}

/*第二层*/
@keyframes anim2X {
  0% {
    left: 200px;
  }
  100% {
    left: 840px;
  }
}

@keyframes anim2Y {
  0% {
    top: 150px;
  }
  100% {
    top: 450px;
  }
}

.ball2 {
  z-index: 3;
  width: 88px;
  height: 88px;
  /*background-color: #f66;*/
  border-radius: 50%;
  position: absolute;
  color: #fff;
  font-size: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  /*background: red;*/
  background-size: 100% 100%;
  -webkit-background-size: 100% 100%;
  /*line-height: 120px;*/
  /*动画执行一次所需时间*/
  animation-duration: 10s, 10s, 20s;
  /*动画以何种运行轨迹完成一个周期*/
  animation-timing-function: cubic-bezier(0.36, 0, 0.64, 1);
  /*动画播放次数,无线循环播放*/
  animation-iteration-count: infinite;
  /*是否轮流反向播放动画 alternate:正向播放*/
  animation-direction: alternate;
  animation-name: anim2X, anim2Y, scale;
}

#lopp2 {
  width: 600px;
  height: 300px;
  border: 2px solid white;
  border-radius: 50%;
  position: absolute;
  left: 254px;
  top: 196px;
}

.circle {
  position: absolute;
  top: 114px;
  left: 250px;
  background: red;
  border-radius: 50%;
  width: 100px;
  height: 100px;
  z-index: 3;
  color: #fff;
  font-size: 16px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  cursor: pointer;
  background: lightgreen;
  background-size: 100% 100%;
  -webkit-background-size: 100% 100%;
}

.container {
  position: relative;
  transform: rotateX(20deg);
  width: 1100px;
  height: 700px;
  margin: 0 auto;
}

#image {
  height: 50px;
  width: 50px;
}

</style>
